<template>
  <div class="wrapp-options">
    <div class="prod-config-loader" v-show="loadVariants">
      <absolute-loader :showLoader="loadVariants"></absolute-loader>
    </div>
    <template v-if="!loadVariants">
      <ColorSelectorSibiling
        class="wrapp-options__generic"
        :product="product"
        @siblingChange="$emit('siblingChange', $event)"
      />
      <div v-for="variant in variants" :key="variant.attribute_id" class="wrapp-options__generic">
        <div v-if="availableComponent[variant.attribute_code] && variant.values" class="wrapp-options__generic__single-option">
          <component
          :is="availableComponent[variant.attribute_code]"
          :options="variant.values"
          :parentAttribute="variant.attribute_id"
          :filterActive="filterActive"
          :filterCode="variant.attribute_code"
          :defaultSelected="hasSelectedOption(variant.attribute_id)"
          :product="product"
          @filterSelected="filterChanged" />
        </div>
        <div v-else>
          <checkbox-filter
          :options="variant.values"
          :parentAttribute="variant.attribute_id"
          :defaultSelected="hasSelectedOption(variant.attribute_id)"
          @filterSelected="filterChanged"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// load component custom
import ColorSelector from './Variants/ColorSelector'
import SizeSelector from './Variants/SizeSelector'
import ColorSelectorSibiling from './Variants/ColorSelectorSibiling'
// default component
import CheckboxFilter from './Variants/CheckboxFilter'
import { EventBus } from '@/helpers'
import { mapState } from 'vuex'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    variants: {
      type: Array,
      required: true
    },
    filterActive: {
      type: Object,
      required: true
    },
    defaultSelection: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      componentToLoad: null
    }
  },
  computed: {
    ...mapState({
      loadVariants: state => state.product.loadConfigurable
    }),
    availableComponent () {
      return {
        'color': ColorSelector,
        'size': SizeSelector
      }
    }
  },
  methods: {
    hasSelectedOption (variantId) {
      if (this.defaultSelection && this.defaultSelection[variantId]) {
        return this.defaultSelection[variantId]
      } else {
        return null
      }
    },
    filterChanged (filterComposed) {
      EventBus.$emit('product:filterChange', filterComposed)
      this.$emit('changeFilter', filterComposed)
    }
  },
  components: {
    AbsoluteLoader,
    ColorSelectorSibiling,
    CheckboxFilter
  }
}
</script>
